import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';

// components
import ExternallyArrangedTitle from '../shared/delivery/ExternallyArrangedTitle';
import ExternallyArrangedDescription from '../shared/delivery/ExternallyArrangedDescription';

// components
import DeliveryOption from '../shared/delivery/DeliveryOption';

const BuyerArrangeDelivery = ({ item, shipmentType, onSelect, isComputing }) => (
    <DeliveryOption
        value="EXTERNALLY_ARRANGED"
        title={<ExternallyArrangedTitle />}
        description={<ExternallyArrangedDescription item={item} />}
        testName="EXTERNALLY_ARRANGED"
        isSelected={shipmentType === 'EXTERNALLY_ARRANGED'}
        onSelect={() => onSelect({ shipmentType: 'EXTERNALLY_ARRANGED' })}
        disabled={isComputing}
    />
);

BuyerArrangeDelivery.propTypes = {
    item: PropTypes.object.isRequired,
    shipmentType: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    isComputing: PropTypes.bool,
};

export default createFragmentContainer(BuyerArrangeDelivery, {
    item: graphql`
        fragment BuyerArrangeDelivery_item on Item {
            ...ExternallyArrangedDescription_item
        }
    `,
});
